import { useCarePlusPrice } from "../../ChoosePlanCarePlusNew/useCarePlusPrice";

interface PriceValueProps {
  value: number;
  className?: string;
  prefix?: string;
  /** Rendered after the currency, e.g. " /Monat". */
  suffix?: string;
}

const PriceValue = ({ value, className = "", prefix = "", suffix = "" }: PriceValueProps) => {
  const { formatPrice } = useCarePlusPrice();
  if (!Number.isFinite(value) || value <= 0) {
    return <span className="inline-block h-5 w-20 animate-pulse rounded bg-[#dee3ed]" aria-label="Price loading" />;
  }

  return (
    <span className={className}>
      {/* The amount never splits from its currency; a prefix ("from") may wrap above it. */}
      {prefix}<span className="whitespace-nowrap">{formatPrice(value)}{suffix}</span>
    </span>
  );
};

export default PriceValue;
